var lazyLoadImages = function(container) {
    new LazyLoad({
        elements_selector: container,
        threshold : 100,
        load_delay: 300
    });
};

jQuery(document).ready(function($){
    lazyLoadImages('.lazy');
});